import { Controller } from '@hotwired/stimulus'

// "Collapse all / Expand all" over the beachy-collapse cards named by its outlet selector.
// Any card open -> the button collapses everything; all closed -> it expands everything.
export default class extends Controller {
  static targets = ['button']
  static outlets = ['beachy-collapse']

  beachyCollapseOutletConnected() {
    this.refresh()
  }

  toggle() {
    const open = !this.anyOpen
    this.beachyCollapseOutlets.forEach(card => card.setOpen(open))
    this.refresh()
  }

  refresh() {
    this.buttonTarget.textContent = this.anyOpen ? 'Collapse all' : 'Expand all'
  }

  get anyOpen() {
    return this.beachyCollapseOutlets.some(card => card.isOpen)
  }
}
